export default __webpack_public_path__ + "static/share-image-91496a528563ad914307e582df6a264f.jpg";